import { styled } from '@pata-app/themes';

export const BusinessBenefitsContainer = styled.section`
  display: grid;

  background: #8ec6b9;

  > div {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;

    padding: 70px 0;
  }

  img {
    width: 80%;

    border-radius: ${({ theme }) => theme.core.border.container.radius}px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.m}`} {
    img {
      width: 60%;
    }

    button {
      cursor: pointer;
      min-width: 150px;
    }
  }
  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 70px auto 70px;

    overflow: hidden;
    > div {
      display: flex;
      align-items: normal;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      grid-column: 1 / span 4;
      grid-row: 2 / span 1;

      padding: 0;
    }

    img {
      object-fit: cover;

      height: 450px;
      width: 30%;
    }
  }
`;

export const BusinessBenefitsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[1]}px;

  height: min-content;

  align-self: center;

  margin: ${({ theme }) => theme.core.sizing[2]}px ${({ theme }) => theme.core.sizing[4]}px;
  color: ${({ theme }) => theme.colors.greyscale.white};
  /* padding: ${({ theme }) => theme.core.sizing[2]}px; */

  h2 {
    margin: 0;

    font-size: 32px;

    span {
      color: ${({ theme }) => theme.core.colors.primary.blue.medium};
    }
  }

  p {
    margin: 0;
  }

  ul {
    padding: 0 16px;

    li {
      font-family: ${({ theme }) => theme.core.fontFamily.openSans};
      font-size: ${({ theme }) => theme.core.fontSizes.ml}px;

      margin-bottom: ${({ theme }) => theme.core.sizing[1]}px;
    }
  }

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    margin: 16px 0;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    padding: 32px;
    width: 60%;

    margin: 0;
    margin-top: initial;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.xxl}`} {
    padding: ${({ theme }) => theme.core.sizing[4]}px 32px 64px 120px;
    padding-top: 70px;
    width: 60%;
  }
`;

export const BusinessBenefit = styled.li`
  list-style: none;

  strong {
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    font-family: ${({ theme }) => theme.core.fontFamily.openSans};
    font-size: 16px;
    font-weight: 600;
  }
  p {
    grid-column: 2 / span 1;
    grid-row: 2 / span 1;
    margin: 0;
    font-family: ${({ theme }) => theme.core.fontFamily.openSans};
    font-size: ${({ theme }) => theme.core.fontSizes.m}px;
    font-weight: 300;
  }

  svg {
    flex: 0 0 auto;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-self: flex-start;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  button {
    border: none;
  }
`;
